import { combineReducers } from 'redux';

import confluence from './confluence/reducer';
import context from './context/reducer';
import external from './external/reducer';
import featureFlags from './feature-flags/reducer';
import flags from './flags/reducer';
import project from './project/reducer';
import ui from './ui/reducer';
import personalization from './personalization/reducer';
import activation from './activation/reducer';
import { type State } from './types';

export default combineReducers<State>({
	confluence,
	context,
	external,
	project,
	ui,
	flags,
	featureFlags,
	personalization,
	activation,
});
